import React, { useEffect, useState } from "react"
import { Container, NavLink } from "react-bootstrap"
import "./dashHeader.css"
import dashboardlogo from "../../img/Luxterior (1).png"
import headerimage from "../../img/header-image.png"
import roomcard1 from "../../img/roomcard1.jpg"
import { GrFavorite } from "react-icons/gr"
import { useLocation, useNavigate } from "react-router-dom"
import { roomsApi, useGetRoomsQuery } from "../../services/roomsServices"
import { useAppDispatch } from "../../app/hooks"
import { searchRoom } from "../../services/slices/rooms"
import { FaBars } from "react-icons/fa6"
// import {
//   useSearchRoomsMutation,
//   useSearchTicketsMutation,
// } from "../../services/ticketsServices"

interface props {
  onClick: () => void
}

const DashHeader = ({ onClick }: props) => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()

  const url = new URL(window.location.href)
  const pathname = url.pathname

  return (
    <div className="dashboard-header">
      <div className="top-header">
        <div className="header-nav">
          <ul className="position-relative">
            {/* <li className={"item-link"}>
              <NavLink
                onClick={() => {
                  navigate("/dash/favs")
                }}
              >
                My Designers
              </NavLink>
            </li> */}
            <li className={"item-link bars-btn d-lg-none"} onClick={onClick}>
              <NavLink>
                <FaBars />
              </NavLink>
            </li>
            <li className={"item-link"}>
              <NavLink
                onClick={() => {
                  navigate("/dash/favs")
                }}
                style={{ fontSize: "20px", fontFamily: "Exo 2" }}
              >
                <GrFavorite className="heart" /> Favorites
              </NavLink>
            </li>
          </ul>
        </div>
        <div className="header-icon">
          <ul>
            {pathname == "/dash/main" && (
              <li>
                <input
                  type="text"
                  placeholder={
                    pathname == "/dash/main" ? "Search Rooms" : "Search"
                  }
                  onChange={(e: any) => {
                    dispatch(searchRoom(e.target.value))
                  }}
                />
              </li>
            )}

            <li>
              <a
                onClick={() => navigate("/dash/experts")}
                className="button-consult"
              >
                Consult a Designer
              </a>
            </li>
            {/* <li>
              <img
                src={headerimage}
                alt="Header"
                onClick={() => navigate("/dash/account")}
              />
            </li> */}
          </ul>
        </div>
      </div>
    </div>
  )
}

export default DashHeader
